import {
    Column,
    Entity,
    Index,
    JoinColumn,
    ManyToOne,
    PrimaryGeneratedColumn, Relation,
} from "typeorm";
import { Project } from "./Project";
import {ProjectProfileGroup} from "./ProjectProfileGroup";

@Index("project_profile_selection_pkey", ["id"], { unique: true })
@Entity("project_selection")
export class ProjectProfileSelection {
  @PrimaryGeneratedColumn({ type: "bigint", name: "id" })
  id!: number;

  @Column("bigint", { name: "profile_group_id" })
  profileGroupId!: number;

  @Column("text", { name: "descriptor_unique_id" })
  descriptorUniqueId!: string;

  @Column("text", { name: "category_unique_id" })
  categoryUniqueId!: string;

  @Column("text", { name: "value", nullable: true })
  value: string | null;

  @ManyToOne((type) => ProjectProfileGroup, (profileGroup) => profileGroup.profileSelections)
  @JoinColumn([{ name: "profile_group_id", referencedColumnName: "id" }])
  profileGroup!: ProjectProfileGroup;

  public getSelectionUniqueId(): string {
    return `${this.categoryUniqueId}|${this.descriptorUniqueId}`;
  }
}
